import { connect } from "react-redux";
import { reduxForm, SubmissionError } from "redux-form";
import { updateFolder } from "../constants/actions";
import UpdateFolderForm from "../components/forms/UpdateFolderForm";

const onSubmit = (values, dispatch) => {
  return new Promise((resolve, reject) => {
    dispatch(updateFolder({ values, resolve, reject }));
  }).catch(error => {
    throw new SubmissionError({ _error: error });
  });
};

const mapStateToProps = state => ({
  initialValues: state.folders.byIds[state.modals.modalProps.id]
});

const Form = reduxForm({
  form: "updateFolderForm",
  onSubmit
})(UpdateFolderForm);

export default connect(mapStateToProps)(Form);



// WEBPACK FOOTER //
// ./src/containers/UpdateFolderForm.js